'use client';
import { IProduct } from '@mybestbrands/types';
import { v4 as uuidv4 } from 'uuid';
import { mapProductsToEcommerceItems, trackSSTEvent } from '@/app/utils/tracking';
import { COOKIE_NAMES } from '@/app/constants';
import { getCookie } from 'cookies-next';
import { useSelector } from 'react-redux';
import { appSettingsState } from '@/app/lib/redux';

type ClickOutCTAProps = {
  product: IProduct;
  locale: string;
  children: React.ReactNode;
};

const ClickOutCTA = ({ product, children, locale }: ClickOutCTAProps) => {
  const { promoHeadLine } = useSelector(appSettingsState);
  const { productId, retailerName, epc, categoryTagNames, name, priorityCoupon } = product;
  const clickCost = epc / 100;

  const onClickOut = () => {
    const transactionId = uuidv4();
    const mbbAttributionCookieEncoded = getCookie(COOKIE_NAMES.MBB_ATTRIBUTION);
    const mbbAttributionCookie = decodeURIComponent(mbbAttributionCookieEncoded as string);
    const attributionObj = mbbAttributionCookie.safeJsonParse();
    const lastSourceQs = attributionObj?.initial_qs || '';

    window.brandName = product.brandName || '';
    window.retailerName = product.retailerName || '';
    window.criteoTransactionItems = [
      {
        id: productId,
        price: clickCost,
        quantity: 1,
      },
    ];

    trackSSTEvent('purchase', {
      'x-mbb-attribution-qs': lastSourceQs,
      transaction_id: transactionId,
      affiliation: retailerName,
      currency: 'EUR',
      value: clickCost,
      items: mapProductsToEcommerceItems([product], promoHeadLine, priorityCoupon?.end_date_utc),
    });

    if (typeof window.fbq === 'function') {
      window.fbq(
        'track',
        'Purchase',
        {
          value: epc / 100,
          currency: 'EUR',
          content_ids: [productId],
          content_type: 'product',
          content_name: name,
          content_category: categoryTagNames.join('/'),
        },
        { eventID: transactionId }
      );
    }

    const localeParam = locale === 'de' ? '' : `/${locale}`;
    window.open(localeParam + '/clickout/' + product.productId + '/?tid=' + transactionId, '_blank');
  };

  return (
    <div className={'cursor-pointer'} onClick={onClickOut}>
      {children}
    </div>
  );
};

export default ClickOutCTA;
